var faqInit;

(function ($) {

	const selectors = {
		wrap: '[data-faq]',
		search: '[data-faq-search]',
		searchItem: '[data-faq-search-item]',
		searchContent: '[data-faq-search-content]',
		group: '[data-category-group]'

	}

	faqInit = function () {
		$(selectors.wrap).each((i, el) => {
			new FAQ(el);
		});
	}

	class FAQ {
		constructor(element) {
			this.$wrap = $(element);

			this.init();
			this.bind();

			this.initSearchable();

		}
		init() {
			this.$searchInput = $(selectors.search, this.$wrap);
			this.$groups = $(selectors.group, this.$wrap);
		}

		bind() {
		}

		initSearchable() {
			this.$wrap.searchable({
				searchField: this.$searchInput,
				selector: selectors.searchItem,

				searchType: 'default',
				childSelector: selectors.searchContent,

				onSearchActive: this.onSearchActive.bind(this),
				onSearchEmpty: this.onSearchEmpty.bind(this),

				show: this.showItem.bind(this),
				hide: this.hideItem.bind(this),
			});
		}
		onSearchEmpty() {
			this.$wrap.removeClass('is-search-active');
		}

		onSearchActive() {
			this.$wrap.addClass('is-search-active');

			this.$groups.each((i, group) => {

				setTimeout(_ => {
					const $group = $(group);
					const $items = $group.find(selectors.searchItem);
					const num_visible = $items.filter('.is-visible').length;

					$group.attr('data-num-results', num_visible);

				}, 50);


			});


		}


		showItem($item) {
			$item.removeClass('is-hidden').addClass('is-visible').show();
		}
		hideItem($item) {
			$item.removeClass('is-visible').addClass('is-hidden').hide();
		}

	}

})(jQuery);


export default faqInit;